<template>
  <div class="SouhuoH5Violationpage" v-if="onLoad">
    <div class="gradePart">
      <div class="con">
        <div class="grade">{{ getBehaviorScore }}</div>
        <div class="tip" @click="goToGradeDesc">{{ getBehaviorScore | gradeDescFilter }}，解读分数<span class="iconfont icon-xiangyou"></span></div>
      </div>
    </div>
    <div class="tabList">
      <van-tabs v-model="currentTab" :animated="isAnimated" swipeable color="#26a2ff" line-width="83px">
        <van-tab v-for="(item, index) in tabList" :key="index" title-class="testClass">
          <template #title>
            <div class="tabItem">
              <div class="itemCon">
                <span :class="item.iconfont" class="iconfont"></span>
                <span v-text="item.name"></span>
              </div>
            </div>
          </template>
          <!-- 内容 -->
          <keep-alive>
            <component
              :is="currentTabComponent"
              :totalViolationpCount="parseInt(getTotalViolationpCount)"
              :list="item.list"
              :limit-info="limitInfo"
              :total="item.total"
              :loading="item.loading"
              :finished="item.finished"
              :isLoad="item.isLoad"
              @linkToMyViolationHistory="linkToMyViolationHistory"
              @loadMore="loadMore"
            ></component>
          </keep-alive>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 顶部展现用户分数&解读分数标签 end -->
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { Tab, Tabs } from 'vant'
import Type from './components/Type'
import Record from './components/Record'
import WaitingHandle from './components/WaitingHandle'
import { mapGetters, mapMutations } from 'vuex'
import { ViolationpPunishRecordList, WaitDoneList, GetBehaviorScoreInfo } from '@/api/my'
export default {
  name: 'SouhuoH5Violationpage',
  components: {
    'van-tabs': Tabs,
    'van-tab': Tab,
    Type,
    Record,
    WaitingHandle
  },
  data() {
    return {
      onLoad: false, // 是否加载完成
      currentTab: null,
      tabList: [
        {
          index: 0,
          iconfont: 'icon-daiban',
          name: '待办事项',
          list: [],
          page: 1,
          total: 1,
          isLoad: false,
          loading: false,
          finished: false,
          methName: 'getWaitDoneList'
        },
        {
          index: 1,
          iconfont: 'icon-weiguiweiji',
          name: '违规记录',
          list: [],
          page: 1,
          total: 1,
          isLoad: false,
          loading: false,
          finished: false,
          methName: 'getViolationpPunishRecordList'
        },
        {
          index: 2,
          iconfont: 'icon-zhenggaileixing',
          name: '违规类型'
        }
      ],
      limitInfo: null,
      isAnimated: false
    }
  },
  computed: {
    ...mapGetters(['getTotalViolationpCount', 'getBehaviorScore']),
    currentTabComponent() {
      let tempComponentName = ''
      switch (this.currentTab) {
        case 0:
          tempComponentName = 'WaitingHandle'
          // 待办事项
          break
        case 1:
          tempComponentName = 'Record'
          // 违规记录
          break
        default:
          tempComponentName = 'Type'
          // 2违规类型
          break
      }
      return tempComponentName
    }
  },
  watch: {
    currentTab: {
      handler(val) {
        if (val === null || this.tabList[val].isLoad) {
          return
        }
        switch (val) {
          case 0:
            this.getWaitDoneList()
            break
          case 1:
            this.getViolationpPunishRecordList()
            break
          default:
            break
        }
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true
    }
  },
  async created() {
    await this.getBehaviorScoreInfo()
    this.onLoad = true
    this.currentTab = Number(this.$route.query.type) || 0
    this.isAnimated = true
  },
  methods: {
    ...mapMutations(['SET_BEHAVIOR_SCORE', 'SET_TOTAL_VIOLATIONP_COUNT']),
    loadMore() {
      console.log('加载更多')
      this[this.tabList[this.currentTab].methName]()
    },
    // 前往分数解答详情
    goToGradeDesc() {
      this.$router.push({
        name: 'gradeDesc'
      })
    },
    // 获取违规记录
    getViolationpPunishRecordList() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = {
        page: this.tabList[this.currentTab].page
      }
      ViolationpPunishRecordList(params)
        .then((res) => {
          Indicator.close()
          this.tabList[this.currentTab].list = [...this.tabList[this.currentTab].list, ...res.DataList]
          this.tabList[this.currentTab].isLoad = true
          this.tabList[this.currentTab].loading = false
          this.tabList[this.currentTab].total = res.total
          this.tabList[this.currentTab].page = this.tabList[this.currentTab].page + 1
          let { IsBuyLimit, IsTALimit, BuyLimitRemoveDate, TALimitRemoveDate, TALimitRemainDayNums, BuyLimitRemainDayNums } = res
          this.limitInfo = {
            IsBuyLimit: IsBuyLimit, // 是否限制购买
            IsTALimit: IsTALimit, // 是否限制提现
            BuyLimitRemoveDate: BuyLimitRemoveDate, // 恢复购买日期
            TALimitRemoveDate: TALimitRemoveDate, // 恢复提现日期
            TALimitRemainDayNums: TALimitRemainDayNums, // 提现剩余限制天数
            BuyLimitRemainDayNums: BuyLimitRemainDayNums // 购买剩余限制天数
          }
          if (this.tabList[this.currentTab].list.length >= res.total) {
            this.tabList[this.currentTab].finished = true
          }
        })
        .catch((res) => {
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
          }
          Indicator.close()
        })
    },
    linkToMyViolationHistory() {
      this.$router.push({
        name: 'myViolationHistory'
      })
    },
    // 获取待办事项
    getWaitDoneList() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      WaitDoneList()
        .then((res) => {
          Indicator.close()
          this.tabList[this.currentTab].list = res.DataList
          this.tabList[this.currentTab].isLoad = true
          this.tabList[this.currentTab].finished = true
          let { IsBuyLimit, IsTALimit, BuyLimitRemoveDate, TALimitRemoveDate, TALimitRemainDayNums, BuyLimitRemainDayNums } = res
          this.limitInfo = {
            IsBuyLimit: IsBuyLimit, // 是否限制购买
            IsTALimit: IsTALimit, // 是否限制提现
            BuyLimitRemoveDate: BuyLimitRemoveDate, // 恢复购买日期
            TALimitRemoveDate: TALimitRemoveDate, // 恢复提现日期
            TALimitRemainDayNums: TALimitRemainDayNums, // 提现剩余限制天数
            BuyLimitRemainDayNums: BuyLimitRemainDayNums // 购买剩余限制天数
          }
        })
        .catch((err) => {
          Toast(err.ErrMsg)
          Indicator.close()
        })
    },
    // 获取用户当前行为分数接口
    getBehaviorScoreInfo() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = {}
      return GetBehaviorScoreInfo(params)
        .then((res) => {
          Indicator.close()
          this.SET_BEHAVIOR_SCORE(parseInt(res.BehaviorScore).toFixed(1))
          this.SET_TOTAL_VIOLATIONP_COUNT(parseInt(res.TotalViolationpCount))
        })
        .catch((res) => {
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
          }
          Indicator.close()
        })
    }
  },
  filters: {
    gradeDescFilter(val) {
      let tempText = ''
      if (val >= 12) {
        tempText = '行为优秀'
      } else if (val >= 7) {
        tempText = '行为良好'
      } else if (val >= 1) {
        tempText = '行为一般'
      } else {
        tempText = '行为恶劣'
      }
      return tempText
    }
  },
  beforeRouteLeave(to, from, next) {
    let keepAliveRouterList = ['gradeDesc', 'violationDetail']
    if (keepAliveRouterList.indexOf(to.name) !== -1) {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    this.isAnimated = false
    next()
  }
}
</script>

<style lang="scss">
.SouhuoH5Violationpage {
  width: 100%;
  min-height: 100vh;
  background-color: #f0f0f2;
  .van-tabs__wrap {
    height: 50px;
  }
}
</style>

<style lang="scss" scoped>
.gradePart {
  display: flex;
  align-items: center;
  width: 100%;
  height: 120px;
  padding: 0 0 19px 26px;
  background: #101010;
  color: #fff;
  box-sizing: border-box;
  .con {
    .grade {
      font-size: 35px;
      line-height: 1em;
    }
    .tip {
      display: flex;
      align-items: center;
      font-size: 12px;
      margin-top: 3px;
      .iconfont {
        font-size: 11px;
        margin-left: 4px;
      }
    }
  }
}
.tabList {
  position: relative;
  width: 100%;
  height: 100%;
  &::before {
    position: absolute;
    content: '';
    top: -19px;
    left: 0;
    width: 100%;
    height: 20px;
    background-color: #fff;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
  }
  .tabItem {
    position: relative;
    display: flex;
    justify-content: space-around;
    height: 50px;
    .itemCon {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      padding: 1px 0 6px;
      .iconfont {
        font-size: 22px;
      }
    }
  }
}
</style>
